import { useState } from 'react';
import { StockClosingActions } from './StockClosingActions';
import { StockClosingHeader } from './StockClosingHeader';
import { StockClosingStatus } from './StockClosingStatus';
import { useStockClosing } from './use-stock-closing';

type StockClosingCardProps = {
  /** If provided, seeds initial date (fetch still runs). */
  lastClosingDate?: string | Date | null;
  /** Backend should recompute all stocks up to TODAY (inclusive). */
  onRunClosing?: () => void | Promise<void>;
  title?: string;
};

export default function StockClosingCard({
  lastClosingDate,
  onRunClosing,
  title = 'Daily Stock Closing',
}: StockClosingCardProps) {
  const [loading, setLoading] = useState(false);

  const {
    lastClosedAt,
    fetching,
    needsClosing,
    missingDays,
    missingStockVariantsCount,
    load,
    setError,
  } = useStockClosing(lastClosingDate);

  async function handleRunClosing() {
    if (!onRunClosing) return;
    setLoading(true);
    setError(null);
    try {
      await onRunClosing();
      // Reload last closing date to update status automatically
      await load();
    } catch (e: any) {
      setError(e?.message ?? 'Failed to start recompute job');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full rounded-xl md:rounded-2xl border bg-white shadow-sm">
      <StockClosingHeader
        title={title}
        status={
          <StockClosingStatus
            fetching={fetching}
            lastClosedAt={lastClosedAt}
            needsClosing={needsClosing}
            missingDays={missingDays}
            missingStockVariantsCount={missingStockVariantsCount}
          />
        }
        actions={
          <StockClosingActions
            loading={loading}
            needsClosing={needsClosing}
            fetching={fetching}
            missingDays={missingDays}
            missingStockVariantsCount={missingStockVariantsCount}
            onRunClosing={handleRunClosing}
            onRefresh={load}
            disabled={!onRunClosing}
          />
        }
      />

      {/* <StockClosingHelper today={today} justRan={justRan} error={error} /> */}
    </div>
  );
}
